import React from "react"
import { Container } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import InvestorsProfileTable from "./table"

const InvestorsProfileUpdate = ({ type = null }) => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={"Profile Update Requests"}
            breadcrumbItem={"Investors"}
          />
          <InvestorsProfileTable type={type} />
        </Container>
      </div>
    </>
  )
}

export default InvestorsProfileUpdate
